import { useQuery, useQueryClient } from "@tanstack/react-query";
import Router from "next/router";
import { CurrentVenueFragment } from "./fragments/current-venue";
import { useVenueId } from "~/store";
import {
	GetCurrentVenueDocument,
	GetCurrentVenueQuery,
} from "~/types/__generated/gql/graphql";
import { gqlReq } from "~/libs/gql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		query GetCurrentVenue {
			getCurrentVenue {
				...CurrentVenueFragment
			}
		}
		${CurrentVenueFragment}
	`
);

export const getCurrentVenueQueryKey = () => ["getCurrentVenue"];
export const getCurrentVenueOfflineQueryKey = () => [
	"getCurrentVenue",
	"offline",
];

export const useGetCurrentVenue = () => {
	const queryClient = useQueryClient();

	const venueId = useVenueId();

	return useQuery({
		enabled: !!venueId,
		queryKey: getCurrentVenueQueryKey(),
		queryFn: async ({ signal }) =>
			gqlReq({
				document: GetCurrentVenueDocument,
				signal,
			}),
		onSuccess: (data) => {
			queryClient.setQueryData(getCurrentVenueOfflineQueryKey(), data);
		},
	});
};

export const useGetCurrentVenueOffline = () => {
	const queryClient = useQueryClient();

	return useQuery({
		queryKey: getCurrentVenueOfflineQueryKey(),
		queryFn: () =>
			queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
				getCurrentVenueOfflineQueryKey(),
			),
	});
};

export const getCurrentVenueCache = () => {
	if (Router.pathname.startsWith("/offline/ops")) {
		return queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
			getCurrentVenueOfflineQueryKey(),
		);
	}
	return queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
		getCurrentVenueQueryKey(),
	);
};
